import en from './en';
import { panelDwiOverrides } from './partials/panelDwiOverrides';
import { panelDepositBonusByLang } from './partials/panelDepositBonusI18n';
import { panelVoucherStatusByLang } from './partials/panelVoucherStatusI18n';
import { panelWithdrawBep20ByLang } from './partials/panelWithdrawBep20I18n';
import { panelDepositVoucherOverrides } from './partials/panelDepositVoucherOverrides';
import { panelInvestmentsOverrides } from './partials/panelInvestmentsI18n';
import { panelStopLossSlotsAssignOverrides } from './partials/panelStopLossSlotsAssignI18n';
import { panelStopLossFlowByLang } from './partials/panelStopLossFlowI18n';
import { panelUserSignupSocialForgotByLang } from './partials/panelUserSignupSocialForgotI18n';
import { panelAgentDashboardByLang } from './partials/panelAgentDashboardI18n';
import { panelAgentReferralsByLang } from './partials/panelAgentReferralsI18n';
import { panelAgentCommissionsByLang } from './partials/panelAgentCommissionsI18n';
import { panelAgentWithdrawByLang } from './partials/panelAgentWithdrawI18n';
import { panelAgentWithdrawUnlockStringsByLang } from './partials/panelAgentWithdrawUnlockStringsI18n';
import { panelAgentTransactionsByLang } from './partials/panelAgentTransactionsI18n';
import { panelAgentLogsByLang } from './partials/panelAgentLogsI18n';
import { panelAgentSettingsByLang } from './partials/panelAgentSettingsI18n';
import { panelAgentNotificationsByLang } from './partials/panelAgentNotificationsI18n';
import { panelAgentTeamByLang } from './partials/panelAgentTeamI18n';
import { panelAgentSignupByLang } from './partials/panelAgentSignupI18n';
import { panelAgentLayoutByLang } from './partials/panelAgentLayoutI18n';
import { panelAgentAuthByLang } from './partials/panelAgentAuthI18n';
import { panelSettingsTransactionsByLang, panelUserExtraByLang } from './partials/panelSettingsTransactions';
import { panelUserPlatformTodayByLang } from './partials/panelUserPlatformTodayI18n';
import { panelStopLossHowLayoutByLang } from './partials/panelStopLossHowLayoutI18n';
import { panelSupportTicketsByLang } from './partials/panelSupportTicketsI18n';
import { panelReferralRankingByLang } from './partials/panelReferralRankingI18n';

function m(p) {
  return { ...en, ...p };
}

export default m({
  'common.theme': 'থিম',
  'common.themeLight': 'লাইট',
  'common.themeDark': 'ডার্ক',
  'common.themeActive': 'বর্তমানে সক্রিয়',
  'common.themeSwitchToDark': 'ডার্কে পরিবর্তন',
  'common.themeSwitchToLight': 'লাইটে পরিবর্তন',
  'common.settings': 'সেটিংস',
  'common.loading': 'লোড হচ্ছে…',
  'settings.language': 'ভাষা',
  'settings.savePreferences': 'সংরক্ষণ করুন',
  'settings.savingPreferences': 'সংরক্ষণ হচ্ছে…',
  'auth.gate.userTitle': 'সেশন যাচাই হচ্ছে',
  'auth.gate.userDescription': 'সাইন-ইন নিশ্চিত করা হচ্ছে।',
  'auth.gate.agentTitle': 'সেশন যাচাই হচ্ছে',
  'auth.gate.agentDescription': 'এজেন্ট সাইন-ইন নিশ্চিত করা হচ্ছে।',
  'user.layout.sidebarTitle': 'MineMe ব্যবহারকারী প্যানেল',
  'user.layout.logout': 'লগআউট',
  'user.layout.nav.dashboard': 'ড্যাশবোর্ড',
  'user.layout.nav.deposit': 'জমা',
  'user.layout.nav.withdraw': 'উত্তোলন',
  'user.layout.nav.investments': 'বিনিয়োগ',
  'user.layout.nav.referral': 'রেফারাল',
  'user.layout.nav.notifications': 'বিজ্ঞপ্তি',
  'user.layout.nav.stopLoss': 'স্টপ-লস',
  'user.layout.nav.transactions': 'লেনদেন',
  'user.layout.nav.settings': 'সেটিংস',
  'user.layout.balance.available': 'উপলব্ধ ব্যালান্স',
  'user.layout.balance.frozen': 'স্থবির ব্যালান্স',
  'user.layout.balance.interest': 'সুদের ব্যালান্স',
  'user.layout.balance.bonus': 'বোনাস ব্যালান্স',
  'user.dashboard.balance.available': 'উপলব্ধ ব্যালান্স',
  'user.dashboard.balance.frozen': 'স্থবির ব্যালান্স',
  'user.dashboard.balance.interest': 'অর্জিত সুদ',
  'user.dashboard.balance.bonus': 'বোনাস ব্যালান্স',

  'common.time.days': 'দিন',
  'common.time.hours': 'ঘণ্টা',
  'common.time.minutes': 'মিনিট',
  'common.time.seconds': 'সেকেন্ড',

  'user.dashboard.title': 'ড্যাশবোর্ড',
  'user.dashboard.loadingInvestments': 'বিনিয়োগের অবস্থা লোড হচ্ছে…',
  'user.dashboard.stats.totalInvested': 'মোট বিনিয়োগ',
  'user.dashboard.stats.netPnl': 'নিট লাভ / ক্ষতি',
  'user.dashboard.stats.activePlans': 'সক্রিয় পরিকল্পনা',
  'user.dashboard.noInvestment.title': 'কোনো সক্রিয় বিনিয়োগ নেই',
  'user.dashboard.noInvestment.subtitle':
    'আজই বিনিয়োগ শুরু করুন এবং আকর্ষণীয় রিটার্নে সম্পদ বাড়ান',
  'user.dashboard.noInvestment.cta': 'বিনিয়োগ পরিকল্পনা দেখুন',
  'user.dashboard.recentTx.title': 'সাম্প্রতিক লেনদেন',
  'user.dashboard.recentTx.viewAll': 'সব দেখুন',
  'user.dashboard.recentTx.col.date': 'তারিখ',
  'user.dashboard.recentTx.col.type': 'ধরন',
  'user.dashboard.recentTx.col.description': 'বিবরণ',
  'user.dashboard.recentTx.col.amount': 'পরিমাণ',
  'user.dashboard.recentTx.col.status': 'অবস্থা',
  'user.dashboard.recentTx.loading': 'সাম্প্রতিক লেনদেন লোড হচ্ছে…',
  'user.dashboard.recentTx.empty': 'কোনো সাম্প্রতিক লেনদেন নেই।',
  'user.dashboard.tx.Deposit': 'জমা',
  'user.dashboard.tx.Investment': 'বিনিয়োগ',
  'user.dashboard.tx.Referral': 'রেফারাল',
  'user.dashboard.tx.Bonus': 'বোনাস',
  'user.dashboard.tx.Withdrawal': 'উত্তোলন',
  'user.dashboard.tx.E-Voucher': 'ই-ভাউচার',
  'user.dashboard.tx.Stop-Loss': 'স্টপ-লস',
  'user.dashboard.st.Completed': 'সম্পন্ন',
  'user.dashboard.st.Active': 'সক্রিয়',
  'user.dashboard.st.Pending': 'অপেক্ষমাণ',
  'user.dashboard.st.Failed': 'ব্যর্থ',
  'user.dashboard.invest.planFallback': 'পরিকল্পনা',
  'user.dashboard.invest.activeBadge': 'সক্রিয়',
  'user.dashboard.invest.detail.amountInvested': 'বিনিয়োগকৃত অর্থ',
  'user.dashboard.invest.detail.currentValue': 'বর্তমান মূল্য',
  'user.dashboard.invest.detail.pl': 'লাভ / ক্ষতি',
  'user.dashboard.invest.detail.interestRate': 'সুদের হার',
  'user.dashboard.invest.detail.perMonth': 'প্রতি মাসে {{pct}}%',
  'user.dashboard.invest.detail.duration': 'মেয়াদ',
  'user.dashboard.invest.detail.months': '{{n}} মাস',
  'user.dashboard.invest.detail.startDate': 'শুরুর তারিখ',
  'user.dashboard.invest.detail.nextWithdrawal': 'পরবর্তী উত্তোলন',
  'user.dashboard.invest.countdownTitle': 'পরবর্তী উত্তোলনে বাকি',
  'user.dashboard.invest.progress': 'অগ্রগতি',
  'user.dashboard.invest.progressPct': '{{pct}}% সম্পূর্ণ',
  'user.dashboard.invest.earlyWithdraw': 'আগাম উত্তোলন',
  'user.dashboard.invest.planChip': '{{name}} #{{num}}',
  'user.dashboard.invest.modal.title': 'সতর্কতা: আগাম উত্তোলন',
  'user.dashboard.invest.modal.investmentAmount': 'বিনিয়োগের পরিমাণ:',
  'user.dashboard.invest.modal.platformFee': 'প্ল্যাটফর্ম ফি ({{pct}}%):',
  'user.dashboard.invest.modal.interestForfeited': 'ছাড়া সুদ:',
  'user.dashboard.invest.modal.youWillReceive': 'আপনি পাবেন:',
  'user.dashboard.invest.modal.confirmHint': 'চালিয়ে যেতে CONFIRM টাইপ করুন',
  'user.dashboard.invest.modal.placeholderConfirm': 'CONFIRM',
  'user.dashboard.invest.modal.confirmWithdraw': 'উত্তোলন নিশ্চিত করুন',
  'user.dashboard.invest.modal.cancelling': 'বাতিল হচ্ছে…',
  'user.dashboard.invest.toast.cancelled': 'বিনিয়োগ বাতিল হয়েছে',
  'user.dashboard.invest.toast.cancelFailed': 'বাতিল করা যায়নি',

  'notifications.bell.triggerAria': 'বিজ্ঞপ্তি',
  'notifications.bell.title': 'বিজ্ঞপ্তি',
  'notifications.bell.loading': 'লোড হচ্ছে…',
  'notifications.bell.loadErrorSubtitle': 'বিজ্ঞপ্তি লোড করা যায়নি',
  'notifications.bell.unreadOne': '১টি অপঠিত আপডেট',
  'notifications.bell.unreadMany': '{{count}}টি অপঠিত আপডেট',
  'notifications.bell.allCaughtUp': 'সব আপডেট দেখা হয়েছে',
  'notifications.bell.markAllRead': 'সব পঠিত চিহ্নিত করুন',
  'notifications.bell.empty': 'এখনও কোনো বিজ্ঞপ্তি নেই',
  'notifications.bell.emptyError': 'বিজ্ঞপ্তি লোড করা যায়নি',
  'notifications.bell.viewAll': 'সব দেখুন',
  'notifications.bell.markReadAria': 'পঠিত চিহ্নিত করুন',
  'notifications.bell.time.justNow': 'এইমাত্র',
  'notifications.bell.time.secondsAgo': '{{n}} সেক আগে',
  'notifications.bell.time.minutesAgo': '{{n}} মি আগে',
  'notifications.bell.time.hoursAgo': '{{n}} ঘণ্টা আগে',
  'notifications.bell.time.daysAgo': '{{n}} দিন আগে',

  'agent.layout.logout': 'লগআউট',
  'agent.layout.nav.dashboard': 'ড্যাশবোর্ড',
  'auth.user.login.title': 'ব্যবহারকারী লগইন',
  'auth.user.login.signIn': 'সাইন ইন',
  'auth.agent.login.title': 'এজেন্ট লগইন',
  'auth.agent.login.signIn': 'সাইন ইন',

  ...panelSettingsTransactionsByLang.bn,
  ...panelReferralRankingByLang.bn,
  ...panelUserExtraByLang.bn,
  ...panelDwiOverrides.bn,
  ...panelDepositBonusByLang.bn,
  ...panelVoucherStatusByLang.bn,
  ...panelWithdrawBep20ByLang.bn,
  ...panelDepositVoucherOverrides.bn,
  ...panelInvestmentsOverrides.bn,
  'user.investments.card.dailyProfit': 'দৈনিক লাভ',
  'user.investments.card.earningDays': 'কর্মদিবস',
  'user.investments.card.earningDaysValue': '{{count}} কর্মদিবস',
  'user.investments.card.expectedProfit': 'প্রত্যাশিত মুনাফা',
  'user.investments.card.investLimit': 'বিনিয়োগ সীমা',
  'user.investments.card.investLimitLine': '{{days}} দিনে {{count}}×',
  'user.investments.card.investLimitReached':
    'বর্তমান সময়ে এই প্ল্যানের বিনিয়োগ সীমায় পৌঁছেছেন।',
  'user.investments.card.limitReached': 'সীমায় পৌঁছেছে',
  ...panelStopLossSlotsAssignOverrides.bn,
  ...panelStopLossFlowByLang.bn,
  ...panelUserSignupSocialForgotByLang.bn,
  ...panelAgentDashboardByLang.bn,
  ...panelAgentReferralsByLang.bn,
  ...panelAgentCommissionsByLang.bn,
  ...panelAgentWithdrawByLang.bn,
  ...panelAgentWithdrawUnlockStringsByLang.bn,
  'agent.withdraw.unlock.loadingTitle': 'উত্তোলনের অবস্থা যাচাই করা হচ্ছে…',
  'agent.withdraw.unlock.loadingSubtitle': 'আপনার রেফারেল অগ্রগতি ও আনলক শর্ত লোড হচ্ছে',
  'agent.withdraw.form.loadingTitle': 'উত্তোলনের বিবরণ লোড হচ্ছে…',
  'agent.withdraw.form.loadingHint': 'ব্যালেন্স ও আনলক অবস্থা লোড হওয়া পর্যন্ত অপেক্ষা করুন',
  'agent.withdraw.unlock.requirementMet': 'শর্ত পূরণ হয়েছে',
  'agent.withdraw.unlock.minDepositHint':
    'শুধু রেফার করা ব্যবহারকারী গণনা হয় (সাব-এজেন্ট নয়)। প্রত্যেকের সম্পন্ন জমা কমপক্ষে ${{amount}} হতে হবে।',
  ...panelAgentTransactionsByLang.bn,
  ...panelAgentLogsByLang.bn,
  ...panelAgentSettingsByLang.bn,
  ...panelAgentNotificationsByLang.bn,
  ...panelAgentTeamByLang.bn,
  ...panelAgentSignupByLang.bn,
  ...panelAgentLayoutByLang.bn,
  ...panelAgentAuthByLang.bn,
  ...panelUserPlatformTodayByLang.bn,
  ...panelStopLossHowLayoutByLang.bn,
  ...panelSupportTicketsByLang.bn,
});
